"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimUploadButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const react_intl_1 = require("react-intl");
const notistack_1 = require("notistack");
const styled_1 = require("@framework/styled");
const provider_api_firebase_1 = require("@dzambalaorg/provider-api-firebase");
const dialogs_1 = require("../../../../dialogs");
const validation_1 = require("./dialog/validation");
const ClaimUploadButton = (props) => {
    const { className, claimType, disabled, onRefreshPage, variant = styled_1.ListActionVariant.button } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const api = (0, provider_api_firebase_1.useApi)();
    const initialValues = {
        claims: [],
        claimType,
    };
    const handleUploadConfirm = (0, react_1.useCallback)(async ({ data }) => {
        const { claims } = data;
        await api
            .fetchJson({
            url: "/claims/upload",
            method: "POST",
            data: {
                claims: claims.map(({ id: _id, ...rest }) => rest),
                claimType,
            },
        })
            .then(async (json) => {
            if (!json?.length || json[0] === null) {
                (0, notistack_1.enqueueSnackbar)(formatMessage({ id: "snackbar.claimsNotUploaded" }), { variant: "error" });
            }
            else {
                (0, notistack_1.enqueueSnackbar)(formatMessage({ id: "snackbar.claimsUploaded" }, { amount: json.length, total: claims.length }), { variant: "success" });
            }
            await onRefreshPage();
        });
    }, []);
    const handleUpload = () => {
        openDialog(dialogs_1.GlobalDialogKeys.CLAIM_UPLOAD, initialValues, {
            initialValues,
            message: "dialogs.upload",
            testId: "ClaimUploadDialog",
            validationSchema: validation_1.claimUploadValidationSchema,
            onExternalConfirm: handleUploadConfirm,
            componentProps: {
                initialValues,
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleUpload, icon: icons_material_1.Add, message: "form.buttons.upload", className: className, dataTestId: "ClaimUploadButton", disabled: disabled, variant: variant }));
};
exports.ClaimUploadButton = ClaimUploadButton;
//# sourceMappingURL=index.js.map